import Vue from 'vue'
import Router from 'vue-router'
import database from './classes/database'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/index.html', name: 'home', component: () => import('./views/Home.vue'), alias: '/' },
    { path: '/scanner', name: 'scanner', component: () => import('./views/Scanner.vue') },
    { path: '/pair', name: 'pair', component: () => import('./views/Pair.vue') },
  ]
})

router.beforeEach((to, from, next) => {
  if (to.name === 'pair') {
    return next();
  }
  Promise.all([database.getConfig('pairing'), database.getConfig('revoked')])
    .then(([pairing, revoked]) => (!pairing || revoked) ? next({ name: 'pair' }) : next())
    .catch(() => next({ name: 'pair' }));
})

export default router
